import {type ComponentType} from 'react'
import {QueryClient} from '@tanstack/react-query'
import {ReactQueryDevtoolsPanel} from '@tanstack/react-query-devtools'
import {Provider} from './provider.js'

const queryClient = new QueryClient()
export function getContext() {
  return {
    queryClient,
  }
}

export const TanstackQuery: {
  getContext: () => {queryClient: QueryClient}
  ReactQueryDevtoolsPanel: ComponentType
  Provider: typeof Provider
} = {
  getContext,
  ReactQueryDevtoolsPanel,
  Provider,
}
